import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    tableContainer: {
        height: "35vh",
        overflowY: "auto",
        "@media (min-width: 1300px)": {
            height: "45vh !important",
            paddingTop: 20,
        },
        "@media (min-width: 1900px)": {
            paddingTop: "unset !important",
        },
    },
    tableRow: {
        "&:last-child td, &:last-child th": { border: 0 },
    },
    tableCell: {
        display: "flex !important",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 12,
    },
    tableCellPadding: {
        padding: `${theme.spacing(2)} !important`,
    },
    title: {
        color: theme.palette.primary.dark,
    },
}));
